/*********************
* Rule base class *
*
* Rules return a bool, describing whether their "logic" condition
* has been satisfied, given a set of inputs
*
* How to use a Rule:
* 1. specify input types
* 2. either provide logic as a param, or by extending the Rule base class
* 3. run it!
*********************/
import { LOG_DECISION_CONTEXT } from '../../config';
import { ruleTypes, phraseLevelRuleInputTypes} from '../../constants';
import {buildLogForRule} from "../../utils/logUtils";

export default class Rule {
  constructor(
      inputTypes=[], // inputTypes is a list of enums, describing the inputs of the rule logic
      logic = () => false, // logic is a function which takes inputTypes, and returns a bool
    ){
    this.inputTypes = inputTypes;
    this.logic = logic;
    this.ruleType = ruleTypes.DEFAULT;
  }

  getInputTypes() {
    return this.inputTypes;
  }

  getRuleType() {
    return this.ruleType;
  }

  // Takes state, where there is a key for each inputType.
  // Runs the rule's logic, and returns a bool based on logic
  run(state) {
    let log;

    // Get the params that we need to run logic from state
    let ruleParams = this.inputTypes.map(type => state[type]);

    // if we're at the word level, and this is a phrase-level rule, return true
    if(!state.endOfPhrase) {
      let isPhraseLevelRule = false;
      const hasAllInputs = Object.keys(ruleParams).every(key => {
        if(phraseLevelRuleInputTypes.includes(key)) {
          isPhraseLevelRule = true;
        }
      });
      if(isPhraseLevelRule) {
        return {
          stateMeetsRuleCondition: true,
          decisionContext: this.ruleType + "condition met by default due to not being applicable at word level",
          log: `${this.ruleType} qualified by default due to not being applicable at word level`,
        }
      }
    }

    let stateMeetsRuleCondition = this.logic(...ruleParams);
    let decisionContext;
    if(LOG_DECISION_CONTEXT) {
      let paramsWithKeys = this.inputTypes.map(type => type + "_" + state[type]);
      decisionContext = {[(this.ruleType + '_' + stateMeetsRuleCondition)]: [paramsWithKeys]};
      log = buildLogForRule(this, state, stateMeetsRuleCondition);
    }

    return {stateMeetsRuleCondition, decisionContext, log};
  }
}